import { cn as e } from "../../shared/utils.js";
import { Button as t } from "../../button/primitive/button.js";
import { Drawer as n } from "../../drawer/index.js";
import { useAdaptiveOverlay as r } from "../../shared/hooks/use-adaptive-overlay.js";
import { Popover as i } from "../../popover/compound-popover.js";
import { XCloseIcon as a } from "@systemeio/icons";
import { twMerge as o } from "tailwind-merge";
import { jsx as s, jsxs as c } from "react/jsx-runtime";
//#region src/date-picker/primitive/popup.tsx
function l({ disabled: l, footer: u, trigger: d, triggerRender: f, open: p, title: m, popupClassName: h, contentClassName: g, footerClassName: _, children: v, onClose: y, onOpenChange: b }) {
	return r(!!p, b) ? /* @__PURE__ */ c(n.Root, {
		open: p,
		onOpenChange: b,
		children: [/* @__PURE__ */ s(n.Trigger, {
			disabled: l,
			nativeButton: !f,
			render: f,
			children: d
		}), /* @__PURE__ */ c(n.Popup, {
			className: h,
			children: [
				(m || y) && /* @__PURE__ */ s(n.Header, { children: /* @__PURE__ */ c("div", {
					className: "flex w-full items-start gap-2",
					children: [/* @__PURE__ */ s("div", {
						className: "min-w-0 flex-1",
						children: m && /* @__PURE__ */ s(n.Title, { children: m })
					}), y && /* @__PURE__ */ s(n.Close, {
						"aria-label": "Close",
						render: /* @__PURE__ */ s(t, {
							size: "icon-sm",
							variant: "ghost-gray"
						}),
						children: /* @__PURE__ */ s(a, {})
					})]
				}) }),
				/* @__PURE__ */ s(n.Content, {
					className: o("gap-0 p-0", g),
					children: v
				}),
				u && /* @__PURE__ */ s(n.Footer, {
					className: _,
					children: u
				})
			]
		})]
	}) : /* @__PURE__ */ c(i.Root, {
		open: p,
		onOpenChange: b,
		children: [/* @__PURE__ */ s(i.Trigger, {
			disabled: l,
			nativeButton: !f,
			render: f,
			children: d
		}), /* @__PURE__ */ s(i.Portal, { children: /* @__PURE__ */ s(i.Positioner, {
			align: "center",
			side: "bottom",
			sideOffset: 8,
			children: /* @__PURE__ */ c(i.Popup, {
				className: e("w-fit max-w-none overflow-hidden", h),
				children: [/* @__PURE__ */ s("div", {
					className: e(g),
					children: v
				}), u && /* @__PURE__ */ s("div", {
					className: e("p-4", _),
					children: u
				})]
			})
		}) })]
	});
}
//#endregion
export { l as Popup };
